import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Chip } from '@material-ui/core';

import { Select } from '../../../components';
import FilterWrapper from '../filter-wrapper';

const styles = {
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  select: {
    width: '100%',
    marginBottom: '10px',
  },
};

class AreaFilter extends Component {
  constructor(props) {
    super(props);

    if (props.selectedLocation) {
      props.loadAreas(props.selectedLocation.id);
    }
  }

  componentDidUpdate(prevProps) {
    const { loadAreas, selectedLocation: oldSelectedLocation } = prevProps;
    const { selectedLocation: newSelectedLocation } = this.props;

    const oldLocationId = oldSelectedLocation ? oldSelectedLocation.id : null;
    const newLocationId = newSelectedLocation ? newSelectedLocation.id : null;

    if (newLocationId && newLocationId !== oldLocationId) {
      loadAreas(newLocationId);
    }
  }

  componentWillUnmount() {
    this.reset();
  }

  handleSelectArea = (event) => {
    const { setFilterOption } = this.props;
    const areaIds = event.target.value;

    setFilterOption({ key: 'areaId', value: areaIds.length > 0 ? areaIds : null });
  }

  reset = () => {
    const { setFilterOption } = this.props;

    setFilterOption({ key: 'areaId', value: null });
  }

  renderSelectedValues = (selectedValues) => {
    const { areas } = this.props;

    if (!selectedValues || selectedValues.length === 0 || areas.length === 0) {
      return <div>Alle</div>;
    }

    return (
      <div className={styles.chips}>
        {selectedValues.map(value => (
          <Chip
            key={value}
            label={areas.find(area => Number.parseInt(area.externalAreaId, 10) === Number.parseInt(value, 10)).name}
          />
        ))}
      </div>
    );
  };

  render() {
    const {
      isAdvancedFilter, areas, selectedAreas,
    } = this.props;

    if (areas.length < 2) {
      return null;
    }

    const areaItems = areas.map(a => (
      <MenuItem key={a.externalAreaId} value={Number.parseInt(a.externalAreaId, 10)}>
        {a.name}
      </MenuItem>
    ));

    return (
      <FilterWrapper
        title="Bereich"
        isAdvancedFilter={isAdvancedFilter}
        resetFilter={this.reset}
        isResetDisabled={selectedAreas.length === 0}
      >
        <Select
          placeholder="Lokal"
          value={[...selectedAreas]}
          onChange={this.handleSelectArea}
          style={styles.select}
          multiple
          displayEmpty
          renderValue={this.renderSelectedValues}
        >
          {areaItems}
        </Select>
      </FilterWrapper>

    );
  }
}

AreaFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  areas: PropTypes.array,
  selectedAreas: PropTypes.array,
  selectedLocation: PropTypes.object,
  loadAreas: PropTypes.func,
  setFilterOption: PropTypes.func,
};

AreaFilter.defaultProps = {
  isAdvancedFilter: false,
  areas: [],
  selectedAreas: [],
  selectedLocation: null,
  loadAreas: () => {},
  setFilterOption: () => {},
};

export default AreaFilter;
